import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { getRadioOptions } from 'src/reducers/selectOptions';
import { CLIENT_ALLOWANCE_FORM } from 'src/constants/FormNames';
import { getAllowanceFormValues } from 'src/reducers/clients/allowances';
import selector from 'src/utils/Utils';

import TreeSelect from './TreeSelect';
import { preparePaymentMonthData } from '../../utils';

const MotivationPaymentMonth = ({ selectedEmployeePay, selectedPaymentMonth, dispatch }) => {
  const paymentsMonths = preparePaymentMonthData(selectedEmployeePay);
  const { t } = useTranslation();

  const getPaymentMonthId = () => {
    const payment = selectedEmployeePay.find(months => months.value === selectedPaymentMonth);
    return payment.paymentMonthId;
  };

  useEffect(
    () => {
      if (selectedPaymentMonth) {
        dispatch(change(CLIENT_ALLOWANCE_FORM, 'employeePaymentMonthId', getPaymentMonthId()));
      }
    },
    [selectedPaymentMonth]
  );

  return <TreeSelect treeData={paymentsMonths} placeholder={t('features.ClientMotivation.components.EffectiveDate.please_select')} />;
};

const mapStateToProps = state => ({
  selectedEmployeePay: getRadioOptions(state, 'employeePaymentMonths'),
  selectedPaymentMonth: selector(getAllowanceFormValues(state), 'employeePaymentMonth')
});

export default connect(mapStateToProps)(MotivationPaymentMonth);
